import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateNote, closePopup, changeText, deleteNote } from "../states/noteState";

const NotePopup = () => {
    const noteState = useSelector(state => state.note)
    const dispatch = useDispatch();
    const popupRef = useRef(null); // here useRef is a react hook and this targetting only pupRef on the DOM 
    const textChangeHandler = e => {
        const { value } = e.target;
        dispatch(changeText(value))
    }
    // Focus trap logic
    useEffect(() => {
        if (!noteState.popupShown || !popupRef.current) return;
    
        const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const stickyFocusable = Array.from(popupRef.current.querySelectorAll(focusableSelector));
        const focusFirstStickyEl = () => stickyFocusable[0]?.focus();
        focusFirstStickyEl();
    
        let dialogTrapCleanup = () => {};
    
        const trapFocus = (container) => {
            const focusableEls = Array.from(container.querySelectorAll(focusableSelector));
            if (focusableEls.length === 0) return () => {};
    
            const [first, last] = [focusableEls[0], focusableEls[focusableEls.length - 1]];
            first?.focus();
    
            const handleKey = (e) => {
                if (e.key !== 'Tab') return;
    
                const index = focusableEls.indexOf(document.activeElement);
                e.preventDefault();
    
                if (e.shiftKey) {
                    focusableEls[index === 0 ? focusableEls.length - 1 : index - 1]?.focus();
                } else {
                    focusableEls[index === focusableEls.length - 1 ? 0 : index + 1]?.focus();
                }
            };
    
            document.addEventListener('keydown', handleKey);
            return () => document.removeEventListener('keydown', handleKey);
        };
    
        const handleStickyKeyDown = (e) => {
            if (e.key !== 'Tab') return;
            if (document.querySelector('.cust-dialog')) return;
    
            const index = stickyFocusable.indexOf(document.activeElement);
            e.preventDefault();
    
            if (e.shiftKey) {
                stickyFocusable[index === 0 ? stickyFocusable.length - 1 : index - 1]?.focus();
            } else {
                stickyFocusable[index === stickyFocusable.length - 1 ? 0 : index + 1]?.focus();
            }
        };
        //Since we are using a function Global.showCustomDialog(...) to render the delete confirmation dialog.This dialog is not part of the React tree of our sticky note, and it likely gets inserted directly into the DOM (e.g., via a portal or global component).
        // MutationObserver :- Detects when .cust-dialog is added and Detects when .cust-dialog is removed. Accordingly it restore and remove focus
        const observer = new MutationObserver((mutations) => {
            mutations.forEach(({ addedNodes, removedNodes }) => {
                addedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.classList.contains('cust-dialog')) {
                        dialogTrapCleanup = trapFocus(node);
                    }
                });
    
                removedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.classList.contains('cust-dialog')) {
                        dialogTrapCleanup?.();
                        if (noteState.popupShown) focusFirstStickyEl();
                    }
                });
            });
        });
    
        observer.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('keydown', handleStickyKeyDown);
    
        return () => {
            observer.disconnect();
            dialogTrapCleanup?.();
            document.removeEventListener('keydown', handleStickyKeyDown);
        };
    }, [noteState.popupShown]);      
        
    return <div className="opr-notePopupcontainer" style={{ display: noteState.popupShown ? "flex" : "none" }}>
        <div ref={popupRef} className="opr-notePopupWrap" aria-modal={ noteState.popupShown ? "true" : "false" } role="dialog" tabIndex="-1" aria-labelledby="notPopupHeading" aria-describedby="notPopupDesc">
            <div className="opr-noteHeader">
                <h2 id="notPopupHeading">Sticky Note</h2>
                <button title="close" aria-label="Close" onClick={() => dispatch(closePopup())}></button>
            </div>
            <div className="opr-noteContent" id="notPopupDesc">
                <textarea id="NotePopup" onChange={textChangeHandler} value={noteState.noteText} />
            </div>
            <div className="opr-noteFooter">
                {!noteState.newPopup && <button aria-label ="delete" title ="delete" className="btn waves-effect waves-light btn-default" onClick={() => Global.showCustomDialog("Are you sure you want to delete this sticky note?", "Please Confirm", function (e) {
                    var response = e.target.value;
                    if (response == 'Yes') {
                        dispatch(deleteNote())
                    }
                }, ["Yes", "No"])}> Delete </button>}
                <button disabled={noteState.noteText === ''} aria-label ="save" title ="save" className="btn waves-effect waves-light btn-primary" onClick={() => dispatch(updateNote())}>save</button>
            </div>
        </div>
    </div >

}
export default NotePopup